import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-20 bg-background-50">
      <div className="text-center">
        <div className="w-20 h-20 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-6">
          <i className="ri-error-warning-line text-4xl text-primary-600"></i>
        </div>
        <h1 className="text-5xl md:text-7xl font-bold text-foreground-900 mb-4">404</h1>
        <p className="text-lg md:text-xl text-foreground-600 mb-2">Page Not Found</p>
        <p className="text-sm text-foreground-400 font-mono mb-8">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-xl font-medium hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-line"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}